import { booleanAttribute, computed, Directive, input } from '@angular/core';
import type { ContextFamily, ContextTone } from '@quipex/shared/utils';
import { resolveTypographyClass } from './color';

@Directive({
    selector: '[qpxBody]',
    host: {
        '[class]': 'className()',
    },
})
export class QpxBody {
    public readonly variant = input<
        ContextFamily | undefined,
        ContextFamily | '' | undefined
    >(undefined, {
        alias: 'qpxBody',
        transform: (value) => value || undefined,
    });

    public readonly tone = input<ContextTone>('default');
    public readonly decorative = input(false, { transform: booleanAttribute });

    public readonly size = input<'sm' | 'md' | 'lg' | 'xl'>('md');

    protected readonly className = computed(() => {
        let text = '';
        switch (this.size()) {
            case 'sm':
                text = 'text-body-sm';
                break;
            case 'md':
                text = 'text-body-md';
                break;
            case 'lg':
                text = 'text-body-lg';
                break;
            case 'xl':
                text = 'text-body-xl';
                break;
        }
        return [
            text,
            'm-0',
            resolveTypographyClass(
                this.variant(),
                this.tone(),
                this.decorative()
            ),
        ].join(' ');
    });
}
